// extracted by mini-css-extract-plugin
export var change = "_3u-1";
export var changeList = "_3u-0";
export var changePath = "_3u-2";
export var diffArrow = "_3u-5";
export var diffRow = "_3u-3";
export var diffValue = "_3u-4";
export var error = "_3u-8";
export var notice = "_3u-9";
export var result = "_3u-6";
export var success = "_3u-7";